import { render, staticRenderFns } from "./ModalLotsMany.vue?vue&type=template&id=422b4e1b&scoped=true&lang=pug&"
import script from "./ModalLotsMany.vue?vue&type=script&lang=js&"
export * from "./ModalLotsMany.vue?vue&type=script&lang=js&"
import style0 from "./ModalLotsMany.vue?vue&type=style&index=0&id=422b4e1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422b4e1b",
  null
  
)

export default component.exports